import styled from 'styled-components';

export const ErrorInfo = styled.div`
  position: absolute;
  align-items: center;
  justify-content: center;
  white-space: pre-line;
  width: 100vw;
  background: ${(props) => (props.background ? '#ED4343' : '#2FB865')};
  opacity: 1;
  padding: ${(props) =>
    `${props.theme.spacing.xSmall} ${props.theme.spacing.base}`};
  margin: 0;

  ${(props) => (props.alert ? 'display: flex' : 'display: none')};
`;

export const Error = styled.p`
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
  margin: 0 0 0 10px;
  font-size: clamp(0.8em, 0.6em + 0.625vw, 0.9em);
`;
